import { NgModule } from '@angular/core';
import { AgrDialogModule } from '@next/core-lib/dialog';
import { provideEffects } from '@ngrx/effects';

import { NvgEffects } from './store/effects';

@NgModule({
  declarations: [],
  imports: [AgrDialogModule],
  providers: [provideEffects([NvgEffects])],
})
export class UpdateNvgModule {}
